module.exports = __webpack_public_path__ + "img/logo1.6f72f896.png";